import { gsap } from 'gsap';

(function($, window) {
    /////////////// BURGER ANIMATION
    const burgerTop = document.getElementById('burger-bar-top');
    const burgerMiddle = document.getElementById('burger-bar-middle');
    const burgerBottom = document.getElementById('burger-bar-bottom');
    let tl = gsap.timeline();

    const open = () => {
        tl = gsap.timeline();
        tl.to(burgerTop, { rotate: 45, duration: 1, y: 7, scaleX: 1.2, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0)
        tl.to(burgerMiddle, { scaleX: 0, duration: 1, opacity: 0, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0)
        tl.to(burgerBottom, { rotate: -45, duration: 1, y: -7, scaleX: 1.2, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0)
    }

    const close = () => {
        tl = gsap.timeline();
        tl.to(burgerTop, { rotate: 0, duration: 1, y: 0, scaleX: 1, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0)
        tl.to(burgerMiddle, { scaleX: 1, duration: 1, opacity: 1, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0)
        tl.to(burgerBottom, { rotate: 0, duration: 1, y: 0, scaleX: 1, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0)
    }

    $(window).on('mobileMenuOpen', () => {
        tl.pause();
        open();
    });

    $(window).on('mobileMenuClose', () => {
        tl.pause();
        close();
    });

    /////////////// BURGER ANIMATION

    //////////// NESTED DRAWERS
    const $drawer = $('nav.drawer');
    const $currentCollectionMenu = $drawer.find('[data-current-collection-menu]');

    const openChildMenu = function() {
        const connectedMenuId = $(this).attr('data-child-menu');
        const $connectedMenu = $('[data-parent-menu="'+ connectedMenuId +'"]');
        $(this).parents('.site-nav__dropdown').find('.site-nav__dropdown-header.first-level').css({'transform':'translateX(-100%)','visibility':'hidden','display':'none'});

        if ($connectedMenu.length){
            gsap.timeline()
            .set($connectedMenu, { display: 'block', autoAlpha: 1 })
            .to($connectedMenu, { x: 0, duration: .35 });
        }
    };

    const closeChildMenu = function() {
        const $connectedMenu = $(this).parents('[data-parent-menu]').eq(0);
        $(this).parents('.site-nav__dropdown').find('.site-nav__dropdown-header.first-level').css({'transform':'translateX(0)','visibility':'visible','display':'block'});

        if ($connectedMenu.length){
            gsap.timeline()
            .to($connectedMenu, { x: '100%', duration: .35 })
            .set($connectedMenu, { display: 'none', autoAlpha: 0 });
        }
    }

    $drawer.on('click', '[data-child-menu]', openChildMenu);
    $drawer.on('click', '[data-close-child-menu]', closeChildMenu);

    // Opening current category menu
    if($currentCollectionMenu.length) {
        openChildMenu.call($currentCollectionMenu);
    }
    //////////// NESTED DRAWERS
})(jQuery, window);
